import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import { useCallback, useState } from 'react';
export const RefreshButton = ({ type, label = 'Refresh', color = 'secondary' }) => {
    const [isRefreshPending, setIsRefreshPending] = useState(false);
    const onClickRefresh = useCallback(() => {
        setIsRefreshPending(true);
        window.location.reload();
    }, []);
    if (type === 'icon') {
        return (_jsx(IconButton, { size: 'small', onClick: onClickRefresh, color: 'primary', title: 'Refresh', disabled: isRefreshPending, children: isRefreshPending ? _jsx(CircularProgress, { size: 20, color: 'inherit' }) : _jsx(RefreshRoundedIcon, {}) }));
    }
    return (_jsx(Button, { variant: 'contained', color: color, onClick: onClickRefresh, endIcon: isRefreshPending ? _jsx(CircularProgress, { size: 20, color: 'inherit' }) : undefined, disabled: isRefreshPending, children: label }));
};
